import { MediaProcessingService } from '@yandex-360/telemost-sdk/device-manager';

import { NoiseCancellationType } from '../../../../../../../common/types/settings';
import { getNoiseCancellationValueByType, getSoundProcessingOptions } from '../../../goloom-sdk/helpers';

export class GoloomMediaProcessing extends MediaProcessingService {
    buildSoundProcessorOptions(noiseCancellationType: NoiseCancellationType): Record<string, unknown> {
        const noiseCancellation = getNoiseCancellationValueByType(noiseCancellationType);

        return {
            ...getSoundProcessingOptions(),
            noiseCancellation,
        };
    }
}
